import React from 'react';
import { ProductTagEditTemplate } from 'themes/application/product-tag/pages';
import { observer } from 'mobx-react';
import { ProductTagEditViewStore } from 'application/product-tag/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new ProductTagEditViewStore(rootStore), 'productTagEditViewStore')
@observer
class ProductTagEdit extends React.Component {
    render() {
        return <ProductTagEditTemplate {...this.props} />
    }
}

export default ProductTagEdit;
